<div class="container mt-4 mb-5 new-order-container">
  <h4 i18n>{{isCopy ? "Copia Pedido" : "Novo Pedido"}}</h4>
  <div *ngFor="let e of errorMsg" class="alert alert-primary" role="alert">
    {{ e }}
  </div>
  <form
    class="new-order-form"
    (ngSubmit)="isCopy ? onCopySubmit() : onSubmit()"
    [formGroup]="form"
  >
    <div class="row">
      <div class="col-12 px-0">
        <div class="form-group mb-1">
          <label>{{ SITE.labelCliente }}</label>
          <app-typeahead
            [onType]="searchFunction"
            [options]="results"
            [onOptionClick]="isCopy ? handleSelectionCopy : handleSelection"
            [loading]="buscandoClientes"
            [disabled]="(!abrePedidoEmGrupo || isCopy) && listCliente.length >= 1"
          ></app-typeahead>
        </div>

        <div class="cliente-status-area mb-2" aria-live="polite">
          <div class="cliente-status-shell">
            <div class="cliente-status-slot">
              <div *ngIf="buscandoClientes" class="cliente-status-msg cliente-status-msg-loading" i18n>
                Aguarde, buscando cliente...
              </div>
              <div
                *ngIf="!buscandoClientes && clienteSelecionado && (errorClienteBloqueado || !clienteIntegrado)"
                class="cliente-status-msg cliente-status-msg-nao-integrado"
              >
                <ng-container *ngIf="errorClienteBloqueado && erroMensagemBloqueio; else textoNaoIntegrado">
                  {{ erroMensagemBloqueio }}
                </ng-container>
                <ng-template #textoNaoIntegrado>
                  <span i18n>Cliente não integrado.</span>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="noResult" class="alert alert-info" i18n>
      Nenhum registro encontrado!
    </div>

    <div class="row new-order-main gx-0 gy-3">
      <div class="col-12 new-order-col-cliente px-0">
        <div
          *ngIf="!clienteSelecionado && !clienteDetalheCarregando"
          class="card card-block card-header p-0 mb-3"
        >
          <div class="alert m-3" i18n>Selecione um ou mais!</div>
        </div>
        <div
          *ngIf="clienteSelecionado || clienteDetalheCarregando"
          class="card card-block card-header p-0 mb-2"
        >
          <div *ngIf="clienteDetalheCarregando" class="cliente-detalhe-skeleton-wrap p-3">
            <div class="row pt-2">
              <div class="col-12 col-lg-4">
                <div class="form-group mb-1" *ngFor="let _ of [1, 2]">
                  <div class="cliente-sk-label"></div>
                  <div class="cliente-sk-value"></div>
                </div>
              </div>
              <div class="col-12 col-lg-4">
                <div class="form-group mb-1" *ngFor="let _ of [1, 2]">
                  <div class="cliente-sk-label"></div>
                  <div class="cliente-sk-value cliente-sk-value-lg"></div>
                </div>
              </div>
              <div class="col-12 col-lg-4">
                <div class="form-group mb-1 invisible">
                  <div class="cliente-sk-label"></div>
                  <div class="cliente-sk-value"></div>
                </div>
                <div class="form-group mb-1">
                  <div class="cliente-sk-label"></div>
                  <div class="cliente-sk-value cliente-sk-value-md"></div>
                </div>
              </div>
            </div>
            <div class="cliente-sk-enderecos mt-1">
              <div class="cliente-sk-th"></div>
              <div class="cliente-sk-addr-row" *ngFor="let _ of [1, 2]">
                <div class="cliente-sk-radio"></div>
                <div class="cliente-sk-addr-text">
                  <div class="cliente-sk-value cliente-sk-value-lg mb-2"></div>
                  <div class="cliente-sk-value cliente-sk-value-sm"></div>
                </div>
              </div>
            </div>
          </div>
          <ng-container *ngIf="!clienteDetalheCarregando && clienteSelecionado">
            <div *ngIf="errorClienteTabela" class="alert alert-danger mb-2" i18n>
              Clientes com tabela de preço diferente!
            </div>
            <div class="row pt-2">
              <div class="col-12 col-lg-4">
                <div class="form-group mb-1">
                  <label i18n>Código</label><br />
                  <b>{{ selectedCliente.codigo }}</b>
                </div>
                <div class="form-group mb-1">
                  <label i18n>Email</label><br />
                  <b>{{ selectedCliente.email }}</b>
                </div>
                <div
                  class="form-group mb-1"
                  *ngIf="selectedCliente.limite_disponivel !== null"
                >
                  <label i18n>limite de crédito disponível</label><br />
                  <b *ngIf="selectedCliente.limite_disponivel !== null"
                    >R$
                    {{
                      selectedCliente.limite_disponivel | currency : "BRL" : ""
                    }}</b
                  >
                </div>
              </div>

              <div class="col-12 col-lg-4">
                <div class="form-group mb-1">
                  <label i18n>Nome</label><br />
                  <b>{{ selectedCliente.nome }}</b>
                </div>
                <div class="form-group mb-1">
                  <label i18n>Fantasia</label><br />
                  <b>{{ selectedCliente.fantasia }}</b>
                </div>
              </div>

              <div class="col-12 col-lg-4" *ngIf="selectedCliente.cidades">
                <div class="form-group mb-1 invisible">
                  <label i18n>Nome</label><br />
                  <b>&nbsp;</b>
                </div>
                <div
                  class="form-group mb-1"
                  [style.color]="selectedCliente.cidades.nome === null ? 'red' : ''"
                >
                  <label i18n>Cidade</label><br />
                  <b>
                    {{ selectedCliente.cidades.nome }}{{ selectedCliente.cidades.uf === "0" ? "" : " - " + selectedCliente.cidades.uf }}
                  </b>
                </div>
              </div>
            </div>
            <div
              *ngIf="selectedCliente.enderecos  && selectedCliente.enderecos.length > 0; else enderecoElseBlock"
              class="row"
            >
              <table class="table table-hover table-condensed mb-0">
                <thead>
                  <tr>
                    <th colspan="2" i18n>Selecione um endereço</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="let a of selectedCliente.enderecos; index as i"
                    (click)="select(a.id)"
                  >
                    <td style="width: 40px">
                      <div
                        class="mt-1 {{
                          clienteIdErp[selectedCliente.id] == a.id
                            ? 'selected-radio'
                            : 'unselected-radio'
                        }}"
                      >
                        <div
                          *ngIf="clienteIdErp[selectedCliente.id] == a.id"
                          class="selected-radio-inside"
                        ></div>
                      </div>
                    </td>
                    <td>
                      <h6 i18n>{{ a.endereco }} {{ a.numero }}</h6>
                      {{ a.uf === "0" ? "" : a.uf+" - "}}{{ a.descricao }} {{ a.cep === "" ? "":"("+ a.cep+")" }}
                      {{ a.bairro ==="" ? "" : ","+a.bairro}}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <ng-template #enderecoElseBlock>
              <table
                *ngIf="selectedCliente.enderecos"
                class="table table-hover table-condensed mb-0"
              >
                <thead>
                  <tr>
                    <th colspan="2" i18n>Selecione um endereço</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style="width: 40px">
                      <input
                        type="radio"
                        value="{{ selectedCliente.idEnderecoErp }}"
                        [(ngModel)]="clienteIdErp[selectedCliente.id]"
                        [ngModelOptions]="{ standalone: true }"
                        [checked]="selectedCliente.enderecos.length === 1"
                        [defaultChecked]="selectedCliente.enderecos.length === 1"
                      />
                    </td>
                    <td>
                      <h6>
                        {{ selectedCliente.endereco }}
                        {{ selectedCliente.numero }}
                      </h6>
                      {{ selectedCliente.uf }} -
                      {{ selectedCliente.descricao }} ({{ selectedCliente.cep }}),
                      {{ selectedCliente.bairro }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </ng-template>
          </ng-container>
        </div>
        <div id="clientes" *ngIf="listCliente.length" class="mb-3 mt-2">
          <span
            *ngFor="let c of listCliente"
            class="badge badge-primary"
            tooltip="{{ c['cliente' + SITE.identificacaoCliente] }}"
            placement="bottom"
          >
            <span (click)="selecionaCliente(c)" class="descr">{{
              c[SITE.identificacaoCliente]
            }}</span>
            <span class="badge badge-light" (click)="isCopy ? excluiClienteCopy(c) : excluiCliente(c)">X</span>
          </span>
        </div>

        <div class="card card-block card-header new-order-pedido-card">
          <div class="p-3">
            <div class="row new-order-pedido-fields g-2">

        

              <div class="col-12 col-md-6 col-xl-4" *ngIf="pedidoTiposUsuario.length > 1 && !isCopy">
                <div class="form-group mb-0">
                  <label>{{ SITE.labelPedidoTipo }}</label>
                  <select
                    id="pedidoTipo"
                    formControlName="pedidoTipo"
                    class="form-control"
                    [(ngModel)]="tipoSelecionado"
                  >
                    <option value="0"></option>
                    <option *ngFor="let t of pedidoTiposUsuario" value="{{ t.id }}">
                      {{ t.tipo }} - {{ t.descricao }}
                    </option>
                  </select>
                  <div
                    *ngIf="error && form.get('pedidoTipo').invalid"
                    class="error"
                    i18n
                  >
                    Verifique este campo!
                  </div>
                </div>
              </div>

              <div class="col-12 col-md-6 col-xl-4" *ngIf="filiais.length > 1">
                <div class="form-group mb-0">
                  <label>{{ SITE.labelFilial }}</label>
                  <select id="filial" formControlName="filial" class="form-control">
                    <option value=""></option>
                    <option *ngFor="let f of filiais" value="{{ f.id }}">
                      {{ f.codigo }} - {{ f.descricao }}
                    </option>
                  </select>
                  <div *ngIf="error && form.get('filial').invalid" class="error" i18n>
                    Verifique este campo!
                  </div>
                </div>
              </div>

              <div class="col-12 col-md-6 col-xl-4" *ngIf="tabelas.length > 1">
                <div class="form-group mb-0">
                  <label>{{ SITE.labelTabela }}</label>
                  <select id="tabela" formControlName="tabela" class="form-control">
                    <option value=""></option>
                    <option *ngFor="let t of tabelas" value="{{ t.id }}">
                      {{ t.codigo }} - {{ t.descricao }}
                    </option>
                  </select>
                  <div *ngIf="error && form.get('tabela').invalid" class="error" i18n>
                    Verifique este campo!
                  </div>
                </div>
              </div>

              <div class="col-12 col-md-6 col-xl-4" *ngIf="filial_Estoque.length > 1">
                <div class="form-group mb-0">
                  <label>Filial de estoque</label>
                  <select
                    id="filialEstoque"
                    formControlName="filialEstoque"
                    class="form-control"
                  >
                    <option value="0"></option>
                    <option *ngFor="let t of filial_Estoque" value="{{ t.id }}">
                      {{ t.codigo }} - {{ t.descricao }}
                    </option>
                  </select>
                  <div
                    *ngIf="error && form.get('filialEstoque').invalid"
                    class="error"
                    i18n
                  >
                    Verifique este campo!
                  </div>
                </div>
              </div>

              <div class="col-12 col-md-6 col-xl-4" *ngIf="SITE.mostraDataEntrega">
                <div class="form-group mb-0">
                  <label>Data de Entrega</label>
                  <input
                    type="text"
                    class="form-control"
                    bsDatepicker
                    formControlName="dataEntrega"
                    [minDate]="dataEntregaMinDate"
                    [daysDisabled]="dataEntregaDaysDisable"
                    [bsConfig]="{
                      isAnimated: true,
                      dateInputFormat: dateFormat,
                      adaptivePosition: true
                    }"
                  />
                  <div
                    *ngIf="error && form.get('dataEntrega').invalid"
                    class="error"
                    i18n
                  >
                    Verifique este campo!
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="new-order-form-footer">
      <button
        type="submit"
        class="btn btn-primary btn-lg new-order-submit-button"
        [disabled]="abrirPedidoDisabled"
        [attr.aria-busy]="abrindoPedido ? 'true' : null"
      >
        <ng-container *ngIf="abrindoPedido; else abrirPedidoLabel">
          <span
            class="spinner-border spinner-border-sm new-order-submit-spinner"
            role="status"
            aria-hidden="true"
          ></span>
          <span i18n>Abrindo pedido...</span>
        </ng-container>
        <ng-template #abrirPedidoLabel>
          <span i18n>Abrir Pedido</span>
        </ng-template>
      </button>
    </div>
  </form>
</div>
